<!-- eslint-disable -->
<template>
  <div class="full-screen-select businiess-screen-statusBar">
    <popup
      ref="popup"
      :full-screen="fullScreen"
      :visible="true"
      :title="title"
      :style="{ 'z-index': zindex }"
      @confirm="popupConfirm"
    >
      <div class="panel-wrap">
        <rich-checkbox-group
          v-model="currentCheckList"
          class="checkbox"
          :options="displayOptions"
        />
      </div>
    </popup>
  </div>
</template>

<script type="text/ecmascript-6">
import Popup from './Popup'
import { i18n } from '@/common/utils/i18n'

export default {
  name: 'FullScreenSelect',
  components: {
    Popup
  },
  props: {
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    title: {
      required: false,
      type: String,
      default: i18n.gettext('请选择')
    },
    options: {
      required: true,
      type: Array,
      default: () => []
    },
    negateValue: {
      required: false,
      type: [String, Number],
      default: undefined
    },
    fullScreen: {
      requried: false,
      type: Boolean,
      default: true
    },
    zindex: {
      requried: false,
      type: Number,
      default: 50
    }
  },
  data () {
    return {
      currentCheckList: this.value.slice(0)
    }
  },
  computed: {
    displayOptions () {
      const currentCheckList = Array.isArray(this.currentCheckList) ? this.currentCheckList : []
      if (this.negateValue === undefined || this.negateValue === null) {
        return this.options
      }
      const negateValue = String(this.negateValue)
      if (!currentCheckList.length) {
        return this.options.map(item => ({
          ...item,
          disabled: false
        }))
      }
      const hasNegateValue = currentCheckList.some(item => String(item) === negateValue)
      return this.options.map(item => ({
        ...item,
        disabled: String(item.value) === negateValue ? !hasNegateValue : hasNegateValue
      }))
    }
  },
  watch: {
    value: {
      deep: true,
      handler (nVal) {
        this.currentCheckList = nVal.slice(0)
      }
    }
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    popupConfirm (callback) {
      this.$emit('confirm', this.currentCheckList)
      // this.$emit('input', this.currentCheckList)
    }
  }
}
</script>

<!-- prettier-ignore -->
<style lang="scss">
// 全局popup样式会覆盖当前文件样式且popup样式修改影响其他页面，因此只能重新写一个全局样式进行设置
.businiess-screen-statusBar{
  .popup {
    .popup-panel{
      padding-top:var(--barheight)!important;
    }
   }
}
</style>

<!-- prettier-ignore -->
<style lang="scss" scoped>
.full-screen-select {
  overflow: auto;
  &-btn {
    // padding: 10px;
    text-align: left;
    color: $color-light-grey;
    font-size: $fontsize-medium;
  }
  ::v-deep .rich-btn-outline:after {
    border: none;
  }
  .panel-wrap {
    width: 100%;
    position: absolute;
    top: 60Px;
    bottom: 0;
    overflow: auto;
    margin-top:var(--barheight)!important;
    .checkbox {
      padding: 0 20px;
    }
  }
}
@media only screen and (min-width: 800px) {
  .full-screen-select {
    .popup {
      width: 600Px;
      margin: 0 auto;
      left: 0;
      right: 0;
    }
  }
}
</style>
